import React from "react";
import hmuLogo from "../static/HMU.png";

export default function OnionsPicture(props) {
  return <img className="center" src={hmuLogo} alt="HMU" />;
}
